import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountKeys } from '~teacher/hook/account';

import { renameTeam } from '../../../api/teams/renameTeam';
import { teamsKeys } from './teamsKeys';

export function useRenameTeam() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: renameTeam,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [teamsKeys.all, accountKeys.account],
      });

      return window.location.reload();
    },
  });
}
